export const FAMILY_EDUCATION_LEVELS = [
  'Não alfabetizado', 'Alfabetização', 'Ensino Fundamental incompleto',
  'Ensino Fundamental completo', 'Ensino Médio incompleto', 'Ensino Médio completo',
  'Ensino Superior incompleto', 'Ensino Superior completo', 'Pós-graduação',
  'Mestrado', 'Doutorado', 'Não informado',
];

export function familyMemberIntegrationColumns() {
  return [
    { id: 'name', label: 'Nome', type: 'text' },
    { id: 'relationship', label: 'Parentesco', type: 'text' },
    { id: 'birthDate', label: 'Data de nascimento', type: 'date' },
    { id: 'whatsapp', label: 'Whatsapp', type: 'phone' },
    { id: 'profession', label: 'Profissão', type: 'text' },
    { id: 'educationLevel', label: 'Escolaridade', type: 'list', options: [...FAMILY_EDUCATION_LEVELS] },
    { id: 'incomeCents', label: 'Renda (R$)', type: 'decimal' },
  ].map(column => ({ ...column, moduleField: column.id, required: false }));
}
